import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import headerImage from './images/header.jpg'
import headerImageDM from './images/header-dm.jpg'
import headerImageMobile from './images/header-mobile.jpg'
import headerImageMobileDM from './images/header-mobile-dm.jpg'
// import headerVideo from './video/header.mp4'
import Authors from 'components/Authors'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

const Header = ({
  tenant,
  colorMode,
  titleText,
  leadText,
  caption,
  authors,
  publishDate,
}: {
  tenant?: object
  colorMode?: string
  titleText?: string | TrustedHTML
  leadText?: string
  caption?: string
  authors?: any
  publishDate?: string
}) => {
  const [hasHeader, setHasHeader] = useState(false)
  const [isMobile, setIsMobile] = useState(true)
  const [isWide, setIsWide] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
    setIsWide(
      window.innerWidth >= 1360 || window.innerWidth > window.innerHeight
    )
  }

  useEffectOnce(() => {
    const headerElement = document.querySelector('[class*=FullHeader_root]')
    if (headerElement) {
      setHasHeader(true)
    }
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <>
      <HeaderWrapper>
        <TopWrapper>
          {/*headerVideo && (
          <div className='header-image'>
            <video playsInline autoPlay loop muted>
              <source
                src={isMobile ? headerVideoWebmMobile : headerVideoWebm}
                type='video/webm'
              />
              <source
                src={isMobile ? headerVideoMobile : headerVideo}
                type='video/mp4'
              />
            </video>
          </div>
        )*/}
          {
            <div className='header-image'>
              <img
                src={
                  isMobile
                    ? colorMode === 'dark'
                      ? headerImageMobileDM
                      : headerImageMobile
                    : colorMode === 'dark'
                    ? headerImageDM
                    : headerImage
                }
                alt='header'
              />
            </div>
          }
          {caption && <Caption>{caption}</Caption>}
        </TopWrapper>
        <div className='title-wrapper'>
          <div className='titles'>
            <h1>
              <span
                dangerouslySetInnerHTML={{
                  __html: titleText ? titleText : 'titleText fehlt',
                }}
              ></span>
            </h1>
          </div>
          <h2>{leadText}</h2>
        </div>
      </HeaderWrapper>
      <div className='authors'>
        {authors && authors.length > 0 && (
          <Authors
            authors={authors}
            publishDate={publishDate}
            tenant={
              tenant
                ? tenant
                : {
                    key: 'tagesanzeiger',
                    name: 'Tages-Anzeiger',
                    domain: 'tagesanzeiger',
                    feedId: 3,
                    lang: 'de',
                  }
            }
          />
        )}
      </div>
    </>
  )
}

const HeaderWrapper = styled.div`
  background-color: var(--header-background);
  .title-wrapper {
    z-index: 2;
    margin: -110px auto 0;
    @media only screen and (max-width: 600px) {
      margin: 0 auto;
      top: -110px;
    }
    width: 668px;
    @media only screen and (max-width: 768px) {
      max-width: 90%;
      top: 0;
    }
    position: relative;
    .titles {
      width: 100%;
      z-index: 99;
      position: relative;
      @media only screen and (max-width: 600px) {
        margin-top: -4.75rem;
      }
      h1 {
        position: relative;
        margin: 0 auto;
        font-family: 'Suez One', serif;
        font-weight: 100;
        color: var(--text-color);
        text-align: center;
        font-size: 3rem;
        line-height: 4rem;
        -webkit-font-smoothing: antialiased;
        span {
          background-color: var(--site-background);
          padding: 0.4rem 1.3rem;
          box-decoration-break: clone;
          -webkit-box-decoration-break: clone;
        }
        @media only screen and (min-width: 768px) {
          font-size: 4.5rem;
          line-height: 5.7rem;
          max-width: 75%;
          _color: yellow;
        }
        @media only screen and (min-width: 1200px) {
          font-size: 5rem;
          line-height: 6.2rem;
          _color: orange;
          _text-shadow: 1px 1px 40px #000, 1px 1px 40px #000;
        }
        @media (orientation: landscape) and (max-height: 1000px) {
          _color: green;
          font-size: 4.8rem;
          line-height: 6rem;
        }
      }
    }
  }

  h2 {
    font-family: var(--font-sans-serif);
    color: var(--text-color);
    font-weight: 400;
    font-size: 1.8rem;
    line-height: 2.7rem;
    padding-bottom: 2rem;
    @media only screen and (min-width: 601px) {
      padding-bottom: 4rem;
    }
  }
`

const Caption = styled.div`
  max-width: 1072px;
  margin: 0 auto;
  font-size: 1.2rem;
  color: #7d7d7d; // var(--meta-data);
  display: grid;
  position: relative;
  @media only screen and (max-width: 768px) {
    padding-left: 1rem;
    top: -1rem;
    text-align: right;
  }
  top: -2rem;
  text-align: left;
  padding-left: 5rem;
  padding-right: 2rem;
  grid-column: 1;
`

const TopWrapper = styled.div`
  overflow: hidden;
  position: relative;
  max-width: 1072px;
  @media only screen and (max-width: 1023px) {
    max-width: 832px;
  }
  margin: 0 auto;

  .header-image {
    position: relative;
    text-align: center;
    img,
    video {
      object-fit: cover;
      width: 100%;
      text-align: center;
    }

    /*
    height: 50vh;
    min-height: 90%;
    @media (orientation: landscape) {
      height: 50vh;
      min-height: 600px;
    }
    @media only screen and (max-width: 768px) {
      height: 40vh;
    }
    @media only screen and (max-width: 600px) {
      height: 23vh;
    }
    @media only screen and (max-width: 400px) {
      height: 30vh;
    }
    img,
    video,
    div {
      width: 100%;
      height: 100%;
      position: absolute;
      object-fit: cover;
      overflow: visible;
      z-index: 1;
    }
    */
  }
`

export default Header
